export default __webpack_public_path__ + "static/media/heroHomeImg.5e31b8ec.png";